// Created by hejikun on 2017/11/2 0002.
let live = [
  {
    path: '/live',
    name: '在线直播',
    component: () => import('@/pages/live/index')
  },
  {
    path: '/live_list',
    name: '直播列表',
    component: () => import('@/pages/live/live_list')
  },
  {
    path: '/new_live',
    name: '直播',
    component: () => import('@/pages/live/new_live')
  },
  {
    path: '/live_type',
    name: '直播列表',
    component: () => import('@/pages/live/live_type')
  },
  {
    path: '/live_abbreviation',
    name: '科普课堂',
    component: () => import('@/pages/live/live_abbreviation')
  },
  {
    path: '/live_all_doctor',
    name: '所有加号医生',
    component: () => import('@/pages/live/live_all_doctor')
  }
]

export default live
